export default __webpack_public_path__ + "static/media/swap.62849ac2.svg";